module.exports = __webpack_public_path__ + "img/20200514_141604.27d38312.jpg";